import { format } from 'date-fns';
import React, { PropsWithChildren, useState } from 'react';

import { DateContext, DateTypes } from './DateContext';

interface DateState {
  startDate: string;
  endDate: string;
}

export const DateProvider: React.FC<PropsWithChildren<object>> = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState<DateState>({
    startDate: format(new Date(), 'yyyy-MM-dd').toString(),
    endDate: format(new Date(), 'yyyy-MM-dd').toString(),
  });
  const [dateType, setDateType] = useState<DateTypes>('last48hours');

  const handleDateChange = (date: DateTypes) => {
    const currentDate = new Date();
    let startDate = '';
    let endDate = '';

    switch (date) {
      case 'today':
        startDate = format(currentDate, 'yyyy-MM-dd').toString();
        endDate = format(currentDate, 'yyyy-MM-dd').toString();
        break;
      case 'last48hours':
        startDate = format(currentDate.setDate(currentDate.getDate() - 1), 'yyyy-MM-dd').toString();
        endDate = format(new Date(), 'yyyy-MM-dd').toString();
        break;
      case 'last7days':
        startDate = format(currentDate.setDate(currentDate.getDate() - 6), 'yyyy-MM-dd').toString();
        endDate = format(new Date(), 'yyyy-MM-dd').toString();
        break;
      case 'last30days':
        startDate = format(
          currentDate.setDate(currentDate.getDate() - 29),
          'yyyy-MM-dd',
        ).toString();
        endDate = format(new Date(), 'yyyy-MM-dd').toString();
        break;
      default:
        startDate = format(new Date(), 'yyyy-MM-dd').toString();
        endDate = format(new Date(), 'yyyy-MM-dd').toString();
        break;
    }

    setSelectedDate({ startDate, endDate });
    setDateType(date);
  };

  const customDateChange = ({ startDate, endDate }: DateState) => {
    setDateType('custom');
    setSelectedDate({ startDate, endDate });
  };

  const handleDateTypeChange = (date: DateTypes) => {
    setDateType(date);
  };

  return (
    <DateContext.Provider
      value={{ selectedDate, handleDateChange, customDateChange, handleDateTypeChange, dateType }}
    >
      {children}
    </DateContext.Provider>
  );
};
